import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.INITIAL_ACTIONS_VALIDATE_SESSION_PATH,
	name: routeList.INITIAL_ACTIONS_VALIDATE_SESSION_NAME,
	component: () => import('@/views/initialActions/ValidateSession')
}, {
	path: routeList.INITIAL_ACTIONS_FIRST_LOGIN_PATH,
	name: routeList.INITIAL_ACTIONS_FIRST_LOGIN_NAME,
	component: () => import('@/views/initialActions/FirstLogin')
}, {
	path: routeList.INITIAL_ACTIONS_CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP_PATH,
	name: routeList.INITIAL_ACTIONS_CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP_NAME,
	component: () => import('@/views/initialActions/ChooseDefaultContractAccountGroup')
}, {
	path: routeList.INITIAL_ACTIONS_SHOW_SECURE_ASSOCIATION_ENROLLMENT_PATH,
	name: routeList.INITIAL_ACTIONS_SHOW_SECURE_ASSOCIATION_ENROLLMENT_NAME,
	component: () => import('@/views/userArea/definitions/SecureAssociationEnrollment')
}, {
    path: routeList.INITIAL_ACTIONS_LOGIN_MIGRATION_PATH,
    name: routeList.INITIAL_ACTIONS_LOGIN_MIGRATION_NAME,
    component: () => import('@/views/initialActions/LoginMigration')
}]
